<div
  class="block"
  [class]="getClasses()"
  (mouseover)="hovered = true"
  (mouseout)="hovered = false"
  (click)="onClick.emit(item())">

  <ng-content select="[breadcrumb-item-prefix]" />
  @if (item()) {
    {{ item().label }}
  }

</div>
@if (item() || level() === 0) {
  <div
    class="arrow"
    (mouseover)="hovered = true"
    (mouseout)="hovered = false"
    (click)="onClick.emit(item())"
    [class]="getClasses()" >
    <mat-icon>chevron_right</mat-icon>
  </div>
}
